const types = [
  { value: "Dog", label: "Dog" },
  { value: "Cat", label: "Cat" },
  { value: "Other", label: "Other" },
];

const crated = [
  { value: "true", label: "My dog will be crated" },
  { value: "false", label: "My dog will be free in the cabin" },
];

const catCrated = [
  { value: "true", label: "My cat will be crated" },
];

const weights = [];
for (let weight = 5; weight <= 150; weight += 5) {
  weights.push({ value: weight, label: `${weight} lb` });
}

export { types, crated, catCrated, weights };
